import React, { useState } from "react";

const Footer = () => {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleFooter = () => setIsExpanded(!isExpanded);

    return (
        <>
            {/* Footer Trigger */}
            {!isExpanded && (
                <div
                    id="footer-trigger"
                    className="footer-trigger"
                    onClick={toggleFooter}
                    style={{
                        position: "fixed",
                        bottom: 0,
                        width: "100%",
                        backgroundColor: "#253053",
                        color: "#fff",
                        textAlign: "center",
                        cursor: "pointer",
                        padding: "10px",
                    }}
                >
                    Apasa pentru a vedea termenii legali și contactul nostru
                </div>
            )}

            {/* Sliding Footer */}
            <section
                id="edvio-footer"
                className="edvio-footer-section position-fixed"
                style={{
                    position: "fixed",
                    bottom: isExpanded ? "0" : "-100%", // Slide up from bottom
                    left: 0,
                    width: "100%",
                    height: "400px",
                    backgroundColor: "#253053",
                    transition: "bottom 0.3s ease-in-out",
                    color: "#fff",
                    paddingTop: "2rem",
                    zIndex: 1000,
                }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5">
                            <div className="edvio-footer-widget pera-content edvio-headline clearfix">
                                <h3 style={{ color: "#fff", fontSize: "30px", fontWeight: "700", paddingBottom: "12px" }}>
                                    Fiți mereu la curent abonându-vă la newsletter-ul nostru!
                                </h3>
                                <p style={{ maxWidth: "max-content", marginBottom: "1rem", color: "#fff" }}>
                                    Veți primi ultimele informații despre produsele și serviciile noastre și, ca bonus, acces exclusiv la oferte speciale eDevize.
                                </p>
                                <form action="" method="POST">
                                    <div className="row" style={{ background: "#f9f9fb", padding: "0.4rem", borderRadius: "12px" }}>
                                        <div className="col-md-8" style={{ padding: 0 }}>
                                            <input
                                                id="nletter"
                                                name="nletter"
                                                type="email"
                                                placeholder="Introduceți adresa dvs. de e-mail"
                                                style={{ padding: "12px", width: "100%", border: "none", background: "#f9f9fb", borderRadius: "10px" }}
                                            />
                                        </div>
                                        <div className="col-md-4" style={{ padding: 0 }}>
                                            <button
                                                type="submit"
                                                className="svabonare hover-btn"
                                                style={{
                                                    lineHeight: 0,
                                                    borderRadius: "10px",
                                                    fontWeight: 700,
                                                    color: "#fff",
                                                    background: "#294DFF",
                                                    padding: "12px",
                                                    width: "100%",
                                                    height: "100%",
                                                    border: "none",
                                                }}
                                            >
                                                Abonați-vă
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="col-lg-2"></div>
                        <div className="col-lg-2">
                            <FooterLinks />
                        </div>
                        <div className="col-lg-3">
                            <FooterContact />
                        </div>
                    </div>

                    {/* Close Button */}
                    <div
                        className="close-footer"
                        onClick={toggleFooter}
                        style={{
                            position: "absolute",
                            top: "10px",
                            right: "20px",
                            cursor: "pointer",
                            color: "#fff",
                            fontSize: "18px",
                        }}
                    >
                        &times;
                    </div>
                </div>

                {/* Footer Logo Image at the Bottom */}
                <div className="edvio-footer-copyright">
                    <div className="container">
                        <div className="edvio-footer-copyright-content">
                            <div className="row" style={{ justifyContent: "center" }}>
                                <div className="col-md-2">
                                    <div className="edvio-copyright-menu">
                                        <img
                                            src="https://4construct.ro/homepage/dt/adminEDV016529/dt/pagini/platforma/setari_platforma/sql/upload/Logo_comunitate_light.png"
                                            alt="logo edvio"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

const FooterLinks = () => (
    <>
        <p><a href="/homepage/" style={{ textDecoration: "none", color: "inherit", fontWeight: 500 }}>Acasă</a></p>
        <p><a href="?p=despre-noi" style={{ textDecoration: "none", color: "inherit", fontWeight: 500 }}>Despre</a></p>
        <p><a href="#" style={{ textDecoration: "none", color: "inherit", fontWeight: 500 }}>Forum</a></p>
        <p><a href="https://edevize.ro/descarca-edevize/" style={{ textDecoration: "none", color: "inherit", fontWeight: 500 }} target="_blank" rel="noopener noreferrer">Descarcă eDevize</a></p>
        <p><a href="?p=legal" style={{ textDecoration: "none", color: "inherit", fontWeight: 500 }}>Legal</a></p>
    </>
);

const FooterContact = () => (
    <div className="edvio-footer-widget edvio-headline ul-li-block clearfix">
        <h3 className="edvio-widget-title" style={{ color: "#fff", textTransform: "uppercase" }}>Contact:</h3>
        <h4 style={{ color: "#fff", fontWeight: 500 }}>0728.449.010</h4>
        <h4 style={{ color: "#fff", fontWeight: 500 }}>office@edevize.ro</h4>
        <h4 style={{ color: "#fff", fontWeight: 500 }}>Ion Minulescu nr.76</h4>
        <h4 style={{ color: "#fff", fontWeight: 500 }}>sector 3, Bucuresti</h4>
        <h4 style={{ color: "#fff", fontWeight: 500 }}>© 2024 | Exenne Technologies</h4>
    </div>
);

export default Footer;
